import { createApp } from "vue";
import { createStore } from "vuex";
import App from "./App.vue";
import router from "./router";
import ContextMenu from "@/components/ContextMenu";
import Icon from "@/components/Icon";
import Modal from "@/components/Modal";
import FlashMessage from "@/components/FlashMessage";

import "@tabler/core/src/scss/tabler.scss";
import "@tabler/core/src/js/tabler";
import "./assets/scss/main.scss";

import { auth, theme, credit } from "./store";
import api from "@/common/api";
import { APP_API_SERVER } from "@/common/config";
import filters from "@/common/filters";

const store = createStore({
    modules: { auth, theme, credit }
});

api.init(APP_API_SERVER, store);

const app = createApp(App);
app.config.globalProperties.$filters = filters;
app.use(FlashMessage, {});
app.component("flash-message", FlashMessage);
app.component("context-menu", ContextMenu);
app.component("icon", Icon);
app.component("modal", Modal);
app.use(router);
app.use(store);
app.mount("#app");
